import { render, staticRenderFns } from "./VisitMgList.vue?vue&type=template&id=2974b10d&scoped=true"
import script from "./VisitMgList.vue?vue&type=script&lang=js"
export * from "./VisitMgList.vue?vue&type=script&lang=js"
import style0 from "./VisitMgList.vue?vue&type=style&index=0&id=2974b10d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974b10d",
  null
  
)

export default component.exports